/**
 * Node.js-specific client with optimizations
 */

import { MemoryIntelligenceClient } from "../core/client.js";
import { MemoryIntelligenceConfig } from "../core/types.js";

/**
 * Node.js-optimized Memory Intelligence Client
 * 
 * This extends the base client with Node.js-specific optimizations:
 * - Environment variable configuration support (LANONASIS_API_KEY, LANONASIS_API_URL)
 * - Automatic API URL configuration
 * - Stream processing capabilities
 */
export class NodeMemoryIntelligenceClient extends MemoryIntelligenceClient {
  constructor(config?: Partial<MemoryIntelligenceConfig>) {
    // Allow configuration from environment variables following Lanonasis pattern
    const finalConfig: MemoryIntelligenceConfig = {
      apiUrl:
        config?.apiUrl ||
        process.env.LANONASIS_API_URL ||
        "https://api.lanonasis.com/api/v1",
      apiKey:
        config?.apiKey ||
        process.env.LANONASIS_API_KEY ||
        "",
      authType: "apiKey",
      timeout: config?.timeout,
      responseFormat: config?.responseFormat || "markdown",
      headers: config?.headers,
    };

    super(finalConfig);
  }

  /**
   * Create client from environment variables
   * Reads LANONASIS_API_KEY and LANONASIS_API_URL from environment
   */
  static fromEnv(overrides?: Partial<MemoryIntelligenceConfig>): NodeMemoryIntelligenceClient {
    return new NodeMemoryIntelligenceClient(overrides);
  }
}
